import React, { useState, useEffect, useContext, useDebugValue } from "react";
import Select from "react-select";
import styled from "styled-components";
import { AppContext } from "../Utils/AppContext";
import { useGetAllCompanies, updateCompanyManagerRefs } from "../Utils/Company";
import { createUser, updateUser, useGetUser } from "../Utils/User";
import Button from "../Base/Button";
import { toast } from "react-toastify";
import { database } from "firebase";

const FormContainer = styled.div`
  margin-top: 30px;

  form {
    label {
      display: flex;
      flex-direction: column;
      margin-bottom: 10px;
    }
    p.error-message {
      margin-bottom: 12px;
      color: #d94a38;
      font-size: 14px;
    }
  }
`;

const Input = styled.input`
  border: ${props => (!props.fieldValid ? "solid 1px #d94a38" : "solid 1px #dbdee5")};
  padding: 10px;
  border-radius: 3px;
  font-size: 14px;
  margin-top: 4px;
`;

const UserForm = ({ uid, cid, formComplete }) => {
  const context = useContext(AppContext);
  const currentUser = context.state.user;

  const { loading: loadingUser, user: userInfo } = useGetUser(uid);
  const { loading: loadingCompanies, companies } = useGetAllCompanies();

  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [role, setRole] = useState("");
  const [company, setCompany] = useState("");

  const [validateForm, setValidateForm] = useState(false);
  const [formValid, setFormValid] = useState(true);

  const [hideCompany, setHideCompany] = useState(false);
  const [companyOptions, setCompanyOptions] = useState([]);

  const [formMode, setFormMode] = useState("create");

  const selectStyles = {
    container: (provided, state) => {
      if (validateForm && !state.hasValue) return { ...provided, border: "solid 1px #d94a38" };
      else return { ...provided };
    }
  };

  const getAvailableRoles = () => {
    var roles = [{ label: "Driver", value: "driver" }];
    if (currentUser.role === "company-manager") {
      roles.push({ label: "Fleet Manager", value: "fleet-manager" });
      roles.push({ label: "Company Manager", value: "company-manager" });
    } else if (currentUser.role === "super") {
      roles.push({ label: "Fleet Manager", value: "fleet-manager" });
      roles.push({ label: "Company Manager", value: "company-manager" });
      roles.push({ label: "Super", value: "super" });
    }
    return roles;
  };

  useEffect(() => {
    if (uid) {
      // Set form mode to edit
      setFormMode("edit");
      if (!loadingUser) {
        setFirstName(userInfo.name.firstName);
        setLastName(userInfo.name.lastName);
        setEmail(userInfo.email);

        if (userInfo.role === "super") {
          setRole({
            label: "Super",
            value: "super"
          });
        } else if (userInfo.role === "company-manager") {
          setRole({
            label: "Company Manager",
            value: "company-manager"
          });
        } else if (userInfo.role === "fleet-manager") {
          setRole({
            label: "Fleet Manager",
            value: "fleet-manager"
          });
        } else {
          setRole({
            label: "Driver",
            value: "driver"
          });
        }

        if (!loadingCompanies) {
          companies.filter(companyInfo => {
            if (companyInfo.cid === userInfo.company.id) {
              console.log("company: " + companyInfo.name);
              return setCompany({
                label: companyInfo.name,
                value: companyInfo.cid
              });
            }
          });
        }
      }

      if (!loadingCompanies && !loadingUser) {
        setCompany({ value: userInfo.companyId, label: userInfo.companyName });
      }
    } else if (cid) {
      if (!loadingCompanies && companies.length > 0) {
        setCompany({
          label: companies[0].name,
          value: companies[0].cid
        });
        setHideCompany(true);
      }
    }

    if (!loadingCompanies) {
      const options = [];
      companies.map((comp, index) => {
        options.push({ value: comp.cid, label: comp.name });
        if (companies.length === index + 1) return setCompanyOptions(options);
      });
    }
  }, [loadingCompanies, loadingUser]);

  return (
    <FormContainer>
      <form>
        <label htmlFor="firstName">
          First Name:
          <Input
            fieldValid={validateForm ? firstName : true}
            type="text"
            name="firstName"
            id="firstName"
            placeholder="First Name"
            onChange={event => {
              setFirstName(event.target.value);
            }}
            value={firstName}
          />
        </label>
        <label htmlFor="lastName">
          Last Name:
          <Input
            fieldValid={validateForm ? lastName : true}
            type="text"
            name="lastName"
            id="lastName"
            placeholder="Last Name"
            onChange={event => {
              setLastName(event.target.value);
            }}
            value={lastName}
          />
        </label>
        <label htmlFor="email">
          Email:
          <Input
            fieldValid={validateForm ? email : true}
            type="text"
            name="email"
            id="email"
            readOnly={formMode !== "create"}
            placeholder="Email"
            onChange={event => {
              setEmail(event.target.value);
            }}
            value={email}
          />
        </label>
        {currentUser.role !== "fleet-manager" && (
          <label htmlFor="role">
            Role:
            <Select
              // defaultValue={}
              // isMulti
              name="role"
              options={getAvailableRoles()}
              className="basic-multi-select"
              classNamePrefix="select"
              placeholder="Select Role"
              styles={selectStyles}
              fieldValid={validateForm ? role : true}
              value={role}
              onChange={event => {
                setRole(event);
                if (event.value === "super") {
                  setCompany({ value: null });
                  setHideCompany(true);
                }
              }}
            />
          </label>
        )}
        {!hideCompany && currentUser.role === "super" && (
          <label htmlFor="company">
            Company:
            <Select
              // defaultValue={}
              // isMulti
              name="company"
              value={company}
              options={companyOptions}
              className="basic-multi-select"
              classNamePrefix="select"
              placeholder="Select Company"
              // defaultValue="a"
              onChange={event => {
                setCompany(event);
              }}
            />
          </label>
        )}

        {!formValid && <p className="error-message">Please fill out all required fields.</p>}

        <Button
          primary
          onClick={e => {
            e.preventDefault();
            if (!firstName || !lastName || !email) {
              setValidateForm(true);
              setFormValid(false);
            } else {
              if (formMode === "create") {
                createUser({
                  email,
                  companyId: company.value,
                  companyName: company.label,
                  firstName,
                  lastName,
                  role: currentUser.role === "fleet-manager" ? "driver" : role.value
                })
                  .then(response => {
                    if (formComplete) {
                      formComplete();
                    }
                    if (response.data.errorInfo) {
                      toast(response.data.errorInfo.message, { type: toast.TYPE.ERROR });
                    } else {
                      toast("User Created", { type: toast.TYPE.INFO });
                    }
                  })
                  // .then(() => window.location.reload())
                  // .then(newUserInfo => {
                  //   if (role.value === "company-manager") {
                  //     updateCompanyManagerRefs(company.value, [db.doc(`users/${}`)]);
                  //   } else if (role.value === "fleet-manager") {
                  //   } else if (role.value === "driver") {
                  //   }
                  // })
                  .catch(
                    error => {
                      // Getting the Error details.
                      console.log(error);
                      const errorCode = error.code;
                      const errorMessage = error.message;
                      Error(`${errorMessage} (${errorCode})`);
                    }
                    // ...
                  );
              } else {
                updateUser(uid, company.value, company.label, firstName, lastName, role.value).then(() => {
                  if (formComplete) {
                    formComplete();
                  }
                });
              }
            }
          }}
          onSubmit={e => {
            e.preventDefault();
          }}
        >
          {formMode === "create" ? "Create User" : "Update User"}
        </Button>
      </form>
    </FormContainer>
  );
};

export default UserForm;
